import templateUrl from "./cmvr-center-main.html";

export const cmvrCenterMainComponent = {
  templateUrl,
  bindings: {
    details: "<",
  },
  controller: class CMVRCenterMainComponent {
    constructor($state, toastr, CMVRCenterService) {
      "ngInject";
      this.CMVRCenterService = CMVRCenterService;
      this.$state = $state;
      this.toastr = toastr;
    }
    $onInit() {
      this.label = "Address"
      if (this.details) {
        this.pageTitle = "edit CMVR center";
      } else {
        this.details = {};
        this.pageTitle = "add new CMVR center";
      }
      this.phoneNumberDetails = {
        phoneNumber: this.details ? this.details.phoneNumber : "",
        phoneCountryCode: this.details.phoneCountryCode
          ? this.details.phoneCountryCode
          : "US",
        phoneDialCode: this.details ? this.details.phoneDialCode : "+1",
      };
      this.disableSubmitBtn = false;
      this.disableAddress =
        this.details && this.details.cmvrCenterId ? true : false;
      this.submitButtonName =
        this.details && this.details.cmvrCenterId ? "Update" : "Submit";
    }
    onSubmit() {
      this.disableSubmitBtn = true;
      const promise = this.details.cmvrCenterId
        ? this.CMVRCenterService.updateCMVRCenter(this.details.cmvrCenterId, {
            name: this.details.name,
            contactPersonName: this.details.contactPersonName,
            email: this.details.email,
            location: this.details.location,
            phoneNumber: this.details.phoneNumber,
            phoneDialCode: this.details.phoneDialCode,
            phoneCountryCode: this.details.phoneCountryCode,
            link: this.details.link ? this.details.link : "",
          })
        : this.CMVRCenterService.addCMVRCenter(this.details);
      promise
        .then(() => {
          this.disableSubmitBtn = false;
          this.toastr.success(
            this.details.cmvrCenterId
              ? "CMVR Center Updated Successfully."
              : "CMVR Center Added Successfully"
          );
          this.$state.go("cmvrCenterList");
        })
        .catch((error) => {
          this.disableSubmitBtn = false;
          this.toastr.error(error.data.errors.message);
        });
    }
    onAddressChange(details) {
      this.details.location = details;
    }
    onPhoneNumberChange(details) {
      this.details = Object.assign(this.details, details);
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/cmvr-center/cmvr-center-main/cmvr-center-main.component.js